"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var core_1 = require("@vueuse/core");
var manageName = vue_1.defineComponent({
    props: {
        data: {
            type: Object,
            default: function () { return ({}); },
        },
        isAuth: {
            type: Boolean,
            default: false,
        },
        isH5: {
            type: Boolean,
            default: false,
        },
    },
    setup: function (props, ctx) {
        var _this = this;
        var data = vue_1.reactive({
            groupProfile: {},
            input: '',
            isEdit: false,
        });
        vue_1.watchEffect(function () {
            data.groupProfile = props.data;
        });
        var dialog = vue_1.ref();
        core_1.onClickOutside(dialog, function () {
            data.isEdit = false;
        });
        var updateProfile = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (data.input && data.input !== data.groupProfile.name) {
                    ctx.emit('update', { key: 'name', value: data.input });
                    data.groupProfile.name = data.input;
                    data.input = '';
                }
                toggleEdit();
                return [2 /*return*/];
            });
        }); };
        var toggleEdit = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (props.isAuth) {
                    data.isEdit = !data.isEdit;
                }
                if (data.isEdit) {
                    data.input = data.groupProfile.name;
                }
                return [2 /*return*/];
            });
        }); };
        return __assign(__assign({}, vue_1.toRefs(data)), { updateProfile: updateProfile,
            toggleEdit: toggleEdit,
            dialog: dialog });
    },
});
exports.default = manageName;
